/* eslint-disable */
// @ts-nocheck
import { reducerWrapper } from '../support/utils';
import { OPEN_LOGOUT_MODAL } from '../actions/LogoutModalActions';
import type { LogoutModalReducer } from '../types/logoutModalTypes';
const INIT_STATE = {
  open: false,
};

function Handler(state: LogoutModalReducer = INIT_STATE, action) {
  switch (action.type) {
    case OPEN_LOGOUT_MODAL:
      return {
        open: true,
      };

    default:
      return state;
  }
}

const LogoutModal = reducerWrapper(INIT_STATE, Handler, {
  request: [],
  error: [],
  resetOn: ['APP_CHANGE'],
});
export default LogoutModal;
